import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import ImgContainer from './components/ImgContainer/ImgContainer';
import LayoutCenter from './components/LayoutCenter/LayoutCenter';
import NotFound from './components/NotFound/NotFound';
import { fetchIndustries, fetchTypeSeries } from './api/services';
import './App.less';

export default function App() {
  const [industries, setIndustries] = useState([]);
  const [typeSeries, setTypeSeries] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [openType, setOpenType] = useState(null);
  const [selectedSeries, setSelectedSeries] = useState(null);
  const [loading, setLoading] = useState(true);
  const [keyword, setKeyword] = useState('');
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    fetchIndustries().then(data => {
      let res = [];
      data.result.forEach(item => {
        switch (item.id) {
          case 'EnterpriseNetwork':
            res[0] = item;
            break;
          case 'IndustrialDigitalization':
            res[1] = item;
            break;
          case 'DigitalEnergy':
            res[2] = item;
            break;
          case 'SmartCommerce':
            res[3] = item;
            break;
          case 'Mobility':
            res[4] = item;
            break;
          case 'CloudServices':
            res[5] = item;
            break;
          default:
            res.push(item);
            break;
        }
      });
      setIndustries(res);
    });
  }, []);
  useEffect(() => {
    if (!industries.length > 0 || !selectedIndustry) return;
    fetchTypeSeries(selectedIndustry).then(data => {
      setTypeSeries(
        data.result.product_categories.filter(
          item =>
            item.hasOwnProperty('product_series') &&
            item.product_series.length > 0
        )
      );
      setLoading(false);
    });
  }, [industries, selectedIndustry]);
  const handleRouter = () => {
    let routes = [];
    if (typeSeries.length > 0) {
      typeSeries.forEach(type => {
        let innerArr = type.product_series.map(series => {
          return (
            <Route
              path={`${type.id}/${series.id}`}
              element={<Navigate to={`${type.id}/${series.id}`} />}
            />
          );
        });
        routes = routes.concat(innerArr);
      });
    }
    return routes;
  };
  let currentHashname = window.location.hash;
  let hashArr = currentHashname.replace('#', '').split('/');
  useEffect(() => {
    if (hashArr[1] === undefined) {
      hashArr[1] = 'EnterpriseNetwork';
    }
    let currentModel = hashArr[1];
    if (!hashArr[2] && typeSeries.length > 0) {
      const pathname = `#/${currentModel}/${typeSeries[0].id}/${typeSeries[0].product_series[0].id}`;
      window.location.href = pathname;
      setSelectedIndustry(currentModel);
    } else if (hashArr[2]) {
      window.location.href = currentHashname;
      setSelectedIndustry(hashArr[1]);
      setOpenType(hashArr[2]);
      setSelectedSeries(hashArr[3]);
    } else if (hashArr[1] === 'EnterpriseNetwork') {
      setSelectedIndustry(currentModel);
    }
  }, [typeSeries]);
  return (
    <HashRouter>
      <div className='myFont'>
        <ImgContainer
          keyword={keyword}
          onChangeKeyword={v => setKeyword(v)}
          onChangeFlag={v => setFlag(v)}
          onChangeSelectedIndustry={v => setSelectedIndustry(v)}
        />
      </div>
      <Routes>
        <Route
          path='/'
          element={
            <LayoutCenter
              flag={flag}
              keyword={keyword}
              onChangeFlag={v => setFlag(v)}
              selectedIndustry={selectedIndustry}
              onChangeSelectedIndustry={v => setSelectedIndustry(v)}
              typeSeries={typeSeries}
              onChangeTypeSeries={v => setTypeSeries(v)}
              industries={industries}
              selectedSeries={selectedSeries}
              onchangeSelectedSeries={v => setSelectedSeries(v)}
              openType={openType}
              onchangeOpenType={v => setOpenType(v)}
              loading={loading}
              onChangeLoading={v => setLoading(v)}
              handleRouter={handleRouter}
            />
          }
        >
          {industries.map(industry => (
            <Route
              path={industry.id}
              element={<Navigate to={industry.id} />}
            >
              {typeSeries.length > 0 && handleRouter()}
            </Route>
          ))}
        </Route>
        {typeSeries.length > 0 && (
          <Route
            path='*'
            element={<NotFound />}
          />
        )}
      </Routes>
    </HashRouter>
  );
}
